/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "My blocks+",
  "description": "Create private or global custom blocks with custom inputs, colors, and more!\nWe make it be addon by extension to take your experience to the next level.",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "info": [
    {
      "type": "info",
      "text": "This addon will automatically load the \"My Blocks+\" extension when creating a project",
      "id": "info"
    },
    {
      "type": "info",
      "text": "Warning: It will load new extension and can't remove in extension manager.",
      "id": "warn"
    }
  ],
  "credits": [
    {
      "name": "SharkPool"
    },
    {
      "name": "CST1229"
    },
    {
      "name": "0znzw"
    },
    {
      "name": "KOSHINO",
      "link": "https://github.com/KOSHINOawa"
    }
  ],
  "dynamicDisable": true,
  "tags": ["new"]
};
export default manifest;
